export default async function removeWishlist(slug: string): Promise<void> {
  try {
    const response = await fetch('/api/delete-from-wishlist', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        slug,
      }),
    });
    if (!response.ok) {
      throw new Error('Error removing from wishlist');
    }
  } catch (err) {
    throw new Error('Error removing from wishlist');
  }
}
